// extracted by mini-css-extract-plugin
module.exports = {"ErrorContainer":"ErrorHandler_ErrorContainer__2mDDf"};